import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import { PopdownMenu } from './PopdownMenu.jsx';

import useHandleTiles from '../../lib/redux/hooks/useHandleTiles';
import { renderMenuButtons, tileDropdownToggle } from './utils';

const TilePopdownMenu = ({ id, ignored, status }) => {
  const { moveTileToProof, copyTile, deleteTile } = useHandleTiles();
  const onShow = useCallback(() => tileDropdownToggle(id, 'show'), [id]);

  const onHide = useCallback(() => tileDropdownToggle(id, 'hide'), [id]);

  return (
    <PopdownMenu
      dropdownId={id}
      afterShow={onShow}
      afterHide={onHide}
      menuProps={{
        className: 'tile-thumbnail-menu',
      }}
      menuElements={renderMenuButtons({
        moveTileToProof,
        copyTile,
        deleteTile,
        tile: { id, ignored, status },
      })}
    />
  );
};

TilePopdownMenu.propTypes = {
  id: PropTypes.string.isRequired,
};

export default TilePopdownMenu;
